//
//
//
//
//
//
//
//
//
//
export default {
  name: "ImagePreview",
  data: function data() {
    return {
      imagePreviewVisible: false
    };
  },
  methods: {
    togglePreviewVisibility: function togglePreviewVisibility() {
      this.imagePreviewVisible = !this.imagePreviewVisible;
    }
  },
  props: {
    image: {
      type: String,
      required: true
    }
  }
};